import { createField, updateField } from '../../actions';
import { EVENT_STEP_VALIDATE } from '../../helpers/consts';

export class CustomerTypeField {
    constructor(options) {
        this.validateMessages = {
            selectAnOption: __('Choose your situation'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.radioButtons = options.radioButtons;
        this.id = options.id;
        this.label = options.label;
        this.stepId = options.stepId;
        this.required = options.required !== undefined ? options.required : true;
        const fieldState = this.state.formFields.find(field => field.id === this.id );
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;
        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.checkedId = this.value;
            this.validate();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        const $radioGroup = document.createElement('div');
        $radioGroup.classList.add('form-group', 'field-group--customerType');

        for (const radioButton of this.radioButtons) {
            const $field = document.createElement('div');
            const $fieldLabel = document.createElement('label');
            const $fieldInput = document.createElement('input');

            $fieldInput.type = 'radio';
            $fieldInput.name = this.id;
            $fieldInput.id = `radio-${radioButton.id}`;
            $fieldInput.checked = ($fieldInput.id === this.value);

            $fieldLabel.setAttribute('for', `radio-${radioButton.id}`);
            $fieldLabel.innerHTML = radioButton.label;

            $field.classList.add('form-check');
            $fieldLabel.classList.add('form-check-label');
            $fieldInput.classList.add('form-check-input');
    
            $fieldLabel.prepend($fieldInput);
            $field.appendChild($fieldLabel);

            $radioGroup.appendChild($field);

            $fieldInput.addEventListener('change', this.validate.bind(this));
        }

        this.store.dispatch(createField(this.id, this.label, this.stepId));

        return $radioGroup;
    }

    validate(e) {
        let inputField = null;

        if (e) {
            inputField = e.target.tagName.toUpperCase() === 'INPUT' ? e.target : null;
            this.checkedId = inputField ?  e.target.id : e.target.getAttribute('for');
            this.value = this.checkedId;
        }

        this.isValid = this.checkedId !== null;

        if (this.isValid) {
            this.$el.classList.remove('is-invalid');
            this.$el.classList.add('is-valid');
        } else {
            this.$el.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.isEmpty;
        }

        this.store.dispatch(updateField(this.id, this.value, this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default CustomerTypeField;
